import React, { useRef } from 'react';
import { Row } from '../../elements';
import { Picker } from './Picker';
import { useSleepTimer } from '../../../hooks/player';
export const TimePicker = () => {
    const timeRef = useRef({
        hours: 0,
        minutes: 0,
    });
    const { addSecondsToTime, setSleepTime, hrsMax, minsMax, } = useSleepTimer();
    const shouldCancel = () => {
        return timeRef.current.hours === 0 && timeRef.current.minutes === 0;
    };
    return (React.createElement(Row, null,
        React.createElement(Picker, { label: "Hours", max: 24, selected: hrsMax, onValueChange: (next, prev) => {
                timeRef.current.hours = next;
                if (shouldCancel()) {
                    setSleepTime();
                    return;
                }
                addSecondsToTime((next - prev) * 60 * 60);
            } }),
        React.createElement(Picker, { label: "Minutes", max: 59, selected: minsMax, onValueChange: (next, prev) => {
                timeRef.current.minutes = next;
                if (shouldCancel()) {
                    setSleepTime();
                    return;
                }
                addSecondsToTime((next - prev) * 60);
            } })));
};
//# sourceMappingURL=TimePicker.js.map